import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {useSelector} from 'react-redux';
import Header from "../layout/Header";
import Search from "../../pages/authorized/Search";
import Sidebar from "../layout/Sidebar";

const PrivateRoute = ({component: Component, ...rest}) => {
    const auth = useSelector((state) => state.auth);
    return(
        <Route
            {...rest}
            render={props =>
                auth.isAuthenticated === true ? (
                    <div className="wrapper">
                        <Sidebar/>
                        <div className="main">
                            <Header/>
                            <Component {...props} />
                        </div>
                    </div>
                ) : (
                    <Redirect to="/"/>
                )
            }
        />
    )
};

export default PrivateRoute;
